const validate = async (name, value, formData, isOnChange = false) => {
  let error = { status: false, message: "" };
  let isField = schema[name];

  const fieldNames = {
    job_title: "Job Title",
    SkillSet: "Skill Set",
    FirstName: "First Name",
    LastName: "Last Name",
    gender: "Gender",
    Email: "Email",
    MobileNo: "Contact Number",
    otherDetails: "Other Details",
  };

  if (isField) {
    let validation = isField;
    for (let i = 0; i < validation.length; i++) {
      switch (validation[i]) {
        case "required":
          if (name === "job_title") {
            if (
              !value ||
              value === "" ||
              (typeof value === "object" && !value.value)
            ) {
              error = {
                status: true,
                message: `${fieldNames[name]} is required`,
              };
              return error;
            }
          } else if (name === "SkillSet") {
            if (!value || value.length === 0) {
              error = {
                status: true,
                message: `${fieldNames[name]} is required`,
              };
              return error;
            }
          }
          // Handling for other fields
          else if (value === "" || value === null || value === undefined) {
            error = {
              status: true,
              message: `${fieldNames[name]} is required`,
            };
            return error;
          }
          break;

        case "select":
          if (value?.value == "") {
            error = { status: true, message: `This field is required` };
            return error;
          }
          break;

        case "mobile":
          const strValue =
            value !== null && value !== undefined ? value.toString() : "";

          // For onChange validation, only check length if there's input
          if (isOnChange && strValue !== "") {
            const digitsOnly = strValue.replace(/\D/g, "");
            if (digitsOnly.length !== 10) {
              error = {
                status: true,
                message: "Contact Number must be 10 digits",
              };
              return error;
            }
          }
          // For form submission, check required first
          else if (!isOnChange && strValue === "") {
            error = {
              status: true,
              message: `${fieldNames[name]} is required`,
            };
            return error;
          }
          break;
      }
    }
  }
  return error;
};

const schema = {
  job_title: ["required"],
  SkillSet: ["required"],
  FirstName: ["required"],
  LastName: ["required"],
  gender: ["required"],
  Email: ["required"],
  MobileNo: ["required", "mobile"],
  otherDetails: ["required"],
};

export default validate;
